module.exports = __webpack_public_path__ + "img/tour.a08f6721.jpg";